import axios from 'axios'
import { ip,ip1 } from '@/assets/js/public.js'
import router from '@/router'

import { Message } from 'element-ui';
// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests = []
 
// 创建一个实例
const service = axios.create({
    baseURL: ip,//process.env.VUE_APP_BASE_API, 
    //timeout: 5000 // request timeout
})
 
// 给实例添加一个setToken方法，用于登录后将最新token动态添加到header，同时将token保存在localStorage中
service.setToken = (token,refreshToken) => {
  instance.defaults.headers['Authorization'] =`Bearer ${token}`
  window.localStorage.setItem('accessToken', token);
  window.localStorage.setItem('refreshToken', refreshToken);
  
}
 
//获取新的token请求
function refreshToken () {
    console.log('获取刷新token');
    var dataObj={
        userId:localStorage.userId,
        userName:localStorage.userName,
        appId:parseFloat(localStorage.appId),
		refreshToken:localStorage.refreshToken
    }
    console.log(dataObj);
    return axios.post(`${ip1}api/account/RefreshToken`,dataObj)
}
//拦截请求时的数据
service.interceptors.request.use(function(config) {
    const token = localStorage.getItem('accessToken');
    config.headers.Authorization = token ? `Bearer ${token}` : '';
    return config;
  }, function(error) {
    return Promise.reject(error);
  });
// 拦截返回的数据
service.interceptors.response.use(response => {
    // 接下来会在这里进行token过期的逻辑处理
    const { code } = response.data
    // 说明token过期了,获取新的token
    if (code === 30002) {
        const config = response.config
        //判断一下状态
        if( !isRefreshing ){
            //修改状态，进入更新token阶段
            isRefreshing = true
            // 获取当前的请求
            return refreshToken().then(res => {
                // 刷新token成功，将最新的token更新到header中，同时保存在localStorage中
                if(res.data.code==20000){
                    //service.setToken(res.data.accessToken,res.data.refreshToken)
                    //重置失败请求的配置
                    response.headers['Authorization'] =`Bearer ${res.data.data.accessToken}`
                    window.localStorage.setItem('accessToken', res.data.data.accessToken);
                    window.localStorage.setItem('refreshToken', res.data.data.refreshToken);
                    //config.baseURL = '' 
                    //已经刷新了token，将所有队列中的请求进行重试
                    requests.forEach(cb => cb(res.data.data.accessToken))
                    // 重试完了别忘了清空这个队列
                    requests = []
                    return service(response.config)
                }
                else{
                    //重新请求token失败，跳转到登录页
                    //window.location.href = '/land '
                    console.log('重新获取token失败',res);
                    router.push('/land')
                }
            }).catch( res=>{
                //重新请求token失败，跳转到登录页
                //window.location.href = '/land '
                console.log('重新获取token异常',res);
                router.push('/land')
            } ).finally( ()=>{
                //完成之后在关闭状态
                isRefreshing = false
            } )
        } else{
            // 正在刷新token，返回一个未执行resolve的promise
            return new Promise((resolve) => {
            // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
                requests.push((token) => {
                    config.headers['Authorization'] = token
                    resolve(service(config))
                })
            })
        }
    }
    else{
        //对相应数据做点什么
      let res=response.data;
      if(res.code && res.code!=20000){
        Message({
              message:res.message||'Error',
              type:'error',
              duration:5*1000
          })
          return Promise.reject(new Error(res.message||'Error'))
      }
      return response
    }
    //return response
}, error => {
    return Promise.reject(error)
})
//暴露
export default service


// WEBPACK FOOTER //
// ./src/http/request.js